var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 58.282 58.282",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_152222920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_152222248",
    className: "fil0",
    d: "M24.186 22.5c-5.447 3.144 2.864 18.724 8.824 15.283l5.526 9.571c-2.515 1.452-4.643 2.367-7.559.7-8.094-4.627-17.005-20.053-16.75-29.255.087-3.196 1.97-4.448 4.433-5.87l5.526 9.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_150519168",
    className: "fil0",
    d: "M26.47 22.24a1.236 1.236 0 01-1.686-.452l-5.21-9.023a1.236 1.236 0 01.452-1.685l2.738-1.581a1.237 1.237 0 011.686.451l5.21 9.024c.34.588.137 1.345-.452 1.685l-2.738 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_226148072",
    className: "fil0",
    d: "M40.702 46.89a1.236 1.236 0 01-1.686-.452l-5.21-9.023a1.236 1.236 0 01.452-1.685l2.738-1.581a1.237 1.237 0 011.686.451l5.21 9.024c.34.588.137 1.345-.452 1.685l-2.738 1.581z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.141 0v.007c8.05 0 15.335 3.26 20.604 8.53a29.046 29.046 0 018.53 20.603h.007v.002h-.007c0 8.05-3.26 15.335-8.53 20.604a29.046 29.046 0 01-20.604 8.529v.007h-.001v-.007c-8.05 0-15.335-3.26-20.604-8.53a29.046 29.046 0 01-8.53-20.604H0h.006c0-8.05 3.26-15.336 8.53-20.605A29.046 29.046 0 0129.14.006V0h.001zm0 3.476v.007-.007c-7.08 0-13.495 2.875-18.142 7.522-4.648 4.648-7.523 11.063-7.523 18.142h.007v.002h-.007c0 7.079 2.875 13.494 7.523 18.14 4.647 4.648 11.063 7.524 18.142 7.524v-.007h.001v.007c7.08 0 13.494-2.876 18.141-7.523 4.648-4.648 7.523-11.063 7.523-18.142h-.007v-.001h.007c0-7.08-2.875-13.494-7.523-18.141C42.636 6.35 36.22 3.476 29.141 3.476z",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.db8271ac50b169b2fa66aff8d9a0ded3.svg";
export { ForwardRef as ReactComponent };